import { render, staticRenderFns } from "./ReportOverWeight.vue?vue&type=template&id=02c0a32e"
import script from "./ReportOverWeight.vue?vue&type=script&lang=js"
export * from "./ReportOverWeight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports